import React from 'react';
import 'react-hawksearch/dist/esm/react-hawksearch.css';
import AppState from 'AppState';
import { Hawksearch, parseLocation } from 'react-hawksearch';
import { History, Location } from 'history';
import Spinner from 'components/shared/Spinner';
import { useHawksearchPreview } from 'components/StoreProvider';
import { Route, Switch } from 'react-router-dom';
import HawksearchPage from 'pages/HawksearchPage';
import CompareItemsPage from 'pages/CompareItemsPage';
import ProductDetailsPage from 'pages/ProductDetailsPage';

interface PreviewSearchProps {
	history: History;
	location: Location;
}

function PreviewSearch(props: PreviewSearchProps) {
	const { store: previewStore } = useHawksearchPreview();
	const searchRequest = parseLocation(location, '/' + previewStore.siteDirectory);
	return (
		<>
			{AppState.hawkConfig.clientGuid ? (
				<Hawksearch config={AppState.hawkConfig} initialSearch={searchRequest}>
					{/* <Switch>
						<Route path="/:clientName/" exact render={() => <HawksearchPage {...props} />} />
						<Route path="/:clientName/compare" exact render={() => <CompareItemsPage {...props} />} />
						<Route path="/:clientName/details" exact render={() => <ProductDetailsPage {...props} />} />
					</Switch> */}
					<HawksearchPage {...props} />
				</Hawksearch>
			) : (
				<Spinner isVisible={true} />
			)}
		</>
	);
}

export default PreviewSearch;
